export default "__VITE_ASSET__Dish1iKA__";